import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

import { DURATION, EASE_OUT } from "./motionPresets";

/**
 * Opens and closes a block smoothly instead of popping it in and out.
 *
 * <Collapse isOpen={isRecurring} className="…">…</Collapse>
 *
 * The height eases between 0 and the block's natural height while the content
 * fades, so whatever sits below glides instead of jumping.
 *
 * Overflow is hidden only *while* it animates: once open it goes back to
 * visible, so date pickers and dropdowns inside the block can still escape it.
 */
const Collapse = ({ isOpen, children, className, duration = DURATION.base }) => {
  const shouldReduce = useReducedMotion();
  const openCloseTransition = shouldReduce
    ? { duration: 0 }
    : { duration, ease: EASE_OUT };

  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          key="collapse-content"
          className={className}
          initial={{ height: 0, opacity: 0, overflow: "hidden" }}
          animate={{
            height: "auto",
            opacity: 1,
            transitionEnd: { overflow: "visible" },
          }}
          exit={{ height: 0, opacity: 0, overflow: "hidden" }}
          transition={openCloseTransition}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Collapse;
